import { render, staticRenderFns } from "./CityItem.vue?vue&type=template&id=afd6b25e&scoped=true&"
import script from "./CityItem.vue?vue&type=script&lang=js&"
export * from "./CityItem.vue?vue&type=script&lang=js&"
import style0 from "./CityItem.vue?vue&type=style&index=0&id=afd6b25e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd6b25e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afd6b25e')) {
      api.createRecord('afd6b25e', component.options)
    } else {
      api.reload('afd6b25e', component.options)
    }
    module.hot.accept("./CityItem.vue?vue&type=template&id=afd6b25e&scoped=true&", function () {
      api.rerender('afd6b25e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/CityItem.vue"
export default component.exports